@if (isDataLoaded) {
  <div class="container profile-container"
    >
    <!-- Heading -->
    <div class="row">
      <div class="col" align="left">
        <h1 i18n class="blue-profile-heading">
        Profile
      </h1>
      </div>
      <div class="col" align="right">
        <app-menu> </app-menu>
      </div>
    </div>
    <div class="row">
      @if (adminUser && adminUser.adminReplicated != '') {
        <h6 class="admin-disclaimer">
          <mat-icon>info</mat-icon>
          Admin view - You are currently viewing this user's data
          <mat-icon>info</mat-icon>
        </h6>
      }
    </div>
    <div class="row justify-content-center">
      <!-- Account Details -->
      <h6 i18n class="descriptive-text">
      <b>
        Email:
      </b>
      <span class="field-data">
        {{userDetails.userEmail}}
      </span>
    </h6>
      <h6 i18n class="descriptive-text" style="margin-top: 10px;">
      <b>
        First Name:
      </b>
      <span class="field-data">
        {{userDetails.firstName}}
      </span>
    </h6>
      <h6 i18n class="descriptive-text">
      <b>
        Last Name:
      </b>
      <span class="field-data">
        {{userDetails.lastName}}
      </span>
    </h6>
      <h6 i18n class="descriptive-text">
      <b>
        FIN:
      </b>
      <span class="field-data">
        {{userDetails.fin}}
      </span>
    </h6>
      <app-language-toggle></app-language-toggle>
      <div class="row" style="margin-top: 15px;">
        <div class="col" style="padding-left: 0px;">
          <button mat-stroked-button (click)="updateService.CheckForUpdates(true)" style="background-color: coral; color: white; font-weight: bold;">Check for Updates</button>
          <span class="field-data" style="margin-left: 8px; font-weight: bold;">v{{ appVersion }}</span>
        </div>
        <div class="col" align="right" style="padding-right: 0px;">
          <button i18n mat-stroked-button [disabled]="adminUser || isSyncing" (click)="syncToCloud()" style="background-color: coral; color: white; font-weight: bold;">Sync Data to Cloud</button>
        </div>
      </div>
      <div class="row info-section" style="margin-top: 15px;"></div>
      <!-- Contact Information -->
      <div class="row"
        style="padding-top: 10px;">
        <div class="col-9" align="left">
          <h3 i18n class="blue-profile-subheading">
          Contact Information
        </h3>
        </div>
        <div class="icon col"
          align="right">
          <button class="edit-button"
            [disabled]="adminUser"
            (click)="contactInfoDialog()">
            <mat-icon>
              edit
            </mat-icon>
          </button>
        </div>
      </div>
      <div class="row">
        <h6 i18n class="descriptive-text">
        <b>
          Address:
        </b>
        <span class="field-data">
          {{userDetails.address}}
        </span>
      </h6>
        <h6 i18n class="descriptive-text">
        <b>
          City:
        </b>
        <span class="field-data">
          {{userDetails.city}}
        </span>
      </h6>
        <h6 i18n class="descriptive-text">
        <b>
          Postal Code:
        </b>
        <span class="field-data">
          {{userDetails.postalCode}}
        </span>
      </h6>
        <h6 i18n class="descriptive-text">
        <b>
          Phone Number:
        </b>
        <span class="field-data">
          {{userDetails.phoneNum}}
        </span>
      </h6>
      </div>
      <div class="row info-section"></div>
      <!-- My Logbooks -->
      <div class="row"
        style="padding-top: 10px;">
        <div class="col-9" align="left">
          <h3 i18n class="blue-profile-subheading">
          My Logbooks
        </h3>
        </div>
      </div>
      <div class="row" style="padding-left: 10px;">
        @if (!years.length) {
          <span i18n class="field-data">
        No available logbooks.
      </span>
        }
      </div>
      <div>
        @for (year of years; track year) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="descriptive-text">
                  <b>{{year}}</b>
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            @for (logbook of groupedLogbooks[year]; track logbook) {
              <mat-expansion-panel>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <span class="descriptive-text">
                      <b i18n>
                    {logbook.gearName, select, Gill Net {Gillnet} Seine {Seine} Troll {Troll}}
                      </b>
                      <span class="field-data">
                        (#{{logbook.logbookID}})
                      </span>
                    </span>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <h6 i18n class="field-data" style="font-size: 14px;">
                  <b>Registered Vessel: </b>
                  {{logbook.vessel.vesselName}} (VRN: {{logbook.vessel.vesselRegistrationNumber}})
                </h6>
                <h6 i18n class="field-data" style="font-size: 14px;">
                  <b>Logbook ID: </b>
                  {{logbook.logbookID}}
                </h6>
                <h6 i18n class="field-data" style="font-size: 14px;">
                  <b>Active: </b>
                  {{logbook.isActive ? 'Yes' : 'No'}}
                </h6>
              </mat-expansion-panel>
            }
          </mat-expansion-panel>
        }
      </div>
      @if (containsGillNet) {
        <div
        class="row info-section"></div>
      }
      @if (!containsGillNet) {
        <div
          class="row info-section"
        style="margin-bottom: 20px;"></div>
      }
      <!-- My Vessels -->
      <div class="row"
        style="padding-top: 10px;">
        <div class="col-9" align="left">
          <h3 i18n class="blue-profile-subheading">
          My Vessels
        </h3>
        </div>
        <div class="icon col"
          align="right">
          <button class="edit-button"
            [disabled]="adminUser"
            (click)="addVesselDialog()">
            <mat-icon>
              add
            </mat-icon>
          </button>
        </div>
      </div>
      <div class="row" style="padding-left: 10px;">
        @if (!vessels.length) {
          <span i18n class="field-data">
        No available vessels.
      </span>
        }
      </div>
      <div>
        @for (vessel of vessels; track vessel; let i = $index) {
          <mat-expansion-panel>
            <mat-expansion-panel-header>
              <mat-panel-title>
                <span class="descriptive-text">
                  <b>
                    {{vessel.vesselName}}
                  </b>
                </span>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <h6 i18n class="field-data" style="font-size: 14px;">
          <b>Vessel Registration Number: </b>
          {{vessel.vesselRegistrationNumber}}
        </h6>
            <button i18n mat-flat-button [disabled]="adminUser" style="background-color: #005d87; color: white; margin-right: 10px;" (click)="editVesselDialog(vessel)">Edit vessel</button>
            <button i18n mat-flat-button [disabled]="adminUser" style="background-color: coral; color: white;" (click)="deleteVessel(vessel, i)">Delete vessel</button>
          </mat-expansion-panel>
        }
      </div>
      <div class="row info-section"></div>
      <!-- My Nets -->
      @if (containsGillNet) {
        <div>
          <div class="row"
            style="padding-top: 10px;">
            <div class="col-9" align="left">
              <h3 i18n class="blue-profile-subheading"
                style="padding-left: 12px;">
            My Nets
          </h3>
            </div>
            <div class="icon col"
              align="right">
              <button class="edit-button"
                (click)="addNetDialog()"
                [disabled]="adminUser"
                style="padding-right: 17px;">
                <mat-icon>
                  add
                </mat-icon>
              </button>
            </div>
          </div>
          <div class="row" style="padding-left: 10px;">
            @if (!nets.length) {
              <span i18n class="field-data">
          No available nets.
        </span>
            }
          </div>
          @for (net of nets; track net; let i = $index) {
            <mat-expansion-panel>
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <span class="descriptive-text">
                    <b>
                      {{net.netName}}
                    </b>
                    <span i18n class="field-data">
                ({net.netType, select, Alaska Twist {Alaska Twist} Multi Strand {Multi Strand} Combination {Combination}})
              </span>
                  </span>
                </mat-panel-title>
              </mat-expansion-panel-header>
              <h6 i18n class="field-data" style="font-size: 14px;">
          <b>Length (in fathoms): </b>
          {{net.length}}
        </h6>
              <h6 i18n class="field-data" style="font-size: 14px;">
          <b>Weedline Depth: </b>
          {{net.weedlineDepth}} {{net.weedlineDepthUnits}}
        </h6>
              <h6 i18n class="field-data" style="font-size: 14px;">
          <b>Hang Ratio ( :1): </b>
          {{net.hangRatio}}
        </h6>
              <h6 i18n class="field-data" style="font-size: 14px;">
          <b>Mesh Size: </b>
          {{net.meshSize}} in
        </h6>
              <h6 i18n class="field-data" style="font-size: 14px;">
          <b>Number of Meshes: </b>
          {{net.numMeshes}}
        </h6>
              @if (net.netType === 'Alaska Twist') {
                <h6 i18n class="field-data"
                  style="font-size: 14px;"
                  >
          <b>Number of Strands: </b>
          {{net.numStrands}}
        </h6>
              }
              <button i18n mat-flat-button [disabled]="adminUser" style="background-color: #005d87; color: white; margin-right: 10px;" (click)="editNetDialog(net, i)">Edit net</button>
              <button i18n mat-flat-button [disabled]="adminUser" style="background-color: coral; color: white;" (click)="deleteNet(net, i)">Delete net</button>
            </mat-expansion-panel>
          }
        </div>
      }
      @if (containsGillNet) {
        <div
          class="row info-section"
        style="margin-bottom: 20px;"></div>
      }
    </div>
  </div>
}
